import { put, takeLatest } from 'redux-saga/effects';

// Action Types
const FETCH_INITIAL_DATA = 'guardian/wrapper/FETCH_INITIAL_DATA';
const SET_LOADING = 'guardian/wrapper/SET_LOADING';
const SET_USER = 'guardian/wrapper/SET_USER';

// Action Creators
export const actions = {
  fetchInitialData: () => ({ type: FETCH_INITIAL_DATA }),
  setLoading: (loading) => ({ type: SET_LOADING, payload: loading }),
  setUser: (user) => ({ type: SET_USER, payload: user }),
};

// Initial State
const initialState = {
  loading: false,
  user: null,
};

// Reducer
export default function wrapperReducer(state = initialState, action) {
  switch (action.type) {
    case SET_LOADING:
      return { ...state, loading: action.payload };
    case SET_USER:
      return { ...state, user: action.payload };
    default:
      return state;
  }
}

// Sagas
export function* fetchInitialDataSaga() {
  yield put(actions.setLoading(true));
  try {
    yield put(actions.setLoading(false));
  } catch (error) {
    console.error('Error fetching initial data:', error);
    yield put(actions.setLoading(false));
  }
}

export function* wrapperSagas() {
  yield takeLatest(FETCH_INITIAL_DATA, fetchInitialDataSaga);
}
